<div class="loading-indicator" *ngIf="pleaseWait">
  <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>

<!-- Save Reminder Banner -->
<div *ngIf="showSaveReminder && httpService.canSavePattern()" class="save-reminder-banner">
  <mat-icon class="save-reminder-icon">save</mat-icon>
  <span class="save-reminder-text">Don't forget to save your pattern!</span>
  <button mat-icon-button (click)="dismissSaveReminder()" class="save-reminder-close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- Early Warning Banner (2/3 patterns used) -->
<div *ngIf="showEarlyWarningBanner" class="early-warning-banner">
  <mat-icon class="early-warning-icon">info</mat-icon>
  <div class="early-warning-content">
    <span class="early-warning-text">
      <strong>You've saved 2 of 3 free patterns!</strong> Upgrade now for unlimited patterns and premium features.
    </span>
    <button mat-stroked-button class="early-warning-upgrade-btn" (click)="onEarlyWarningUpgradeClick()">
      View Plans
    </button>
  </div>
  <button mat-icon-button (click)="dismissEarlyWarningBanner()" class="early-warning-close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- Onboarding Checklist -->
<app-onboarding-checklist (checklistClosed)="onOnboardingChecklistClosed()"
  (stepClicked)="onChecklistStepClicked($event)"
  (nextStepChanged)="onNextStepChanged($event)"></app-onboarding-checklist>

<app-toolbar #appToolbar [windowWidth]="windowWidth" [windowHeight]="windowHeight" [bcanvas]="bcanvas"
  [rightSidebarOpen]="rightSidebarOpen" (toolbarActionFired)="onToolbarActionFired($event)"
  class="layout-max-width main-toolbar" data-testid="main-toolbar">
</app-toolbar>

<div *ngIf="!rightSidebarOpen || windowWidth > 768"
  style="position: fixed; z-index: 900; padding-left: 0px; display: flex; align-items: center;"
  [style.left]="smallToolbarLeft + 'px'" [style.top]="smallToolbarTop + 'px'"
  [style.flexDirection]="windowWidth > minSideToolbarWidth ? 'column' : 'row'"
  [style.transform]="windowWidth <= minSideToolbarWidth ? 'translateX(-50%)' : 'none'" class="small-toolbar-container">
  <mat-button-toggle-group #smallToolbar [value]="selectedEditMode" vertical="true"
    (change)="onSelectedEditModeChanged($event)" style="margin-left: 8px"
    [style.flexDirection]="windowWidth > minSideToolbarWidth ? 'column' : 'row'" data-testid="small-toolbar"
    class="small-toolbar">
    <mat-button-toggle value="add-bead" matTooltip="{{ httpService.getTransation().AddBead + ' ' + brushShortcut }}">
      <mat-icon>edit</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="fill" matTooltip="{{ httpService.getTransation().Fill + ' ' + fillShortcut }}">
      <mat-icon>format_paint</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="remove-bead"
      matTooltip="{{ httpService.getTransation().RemoveBead + ' ' + eraserShortcut }}">
      <mat-icon>clear</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="remove-fill"
      matTooltip="{{ httpService.getTransation().RemoveFill + ' ' + removeFillShortcut }}">
      <mat-icon>format_clear</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="pick-bead"
      matTooltip="{{ httpService.getTransation().PickBead + ' ' + pickBeadShortcut }}">
      <mat-icon>colorize</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle *ngIf="hasTouchScreen" value="pan"
      matTooltip="{{ httpService.getTransation().Pan + ' ' + panShortcut }}">
      <mat-icon>pan_tool</mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>

  <div *ngIf="currentBeadColor" class="current-bead-indicator" [style.backgroundColor]="'#' + currentBeadColor"
    [style.marginTop]="windowWidth > minSideToolbarWidth ? '8px' : '0'"
    [style.marginLeft]="windowWidth > minSideToolbarWidth ? '0' : '8px'" matTooltip="Current Bead Color">
  </div>
</div>

<mat-sidenav-container>
  <mat-sidenav-content layout-fill style="overflow: hidden" (click)="onCanvasClick()">
    <app-bead-canvas #beadCanvasComponent [home]="this" [bcanvas]="bcanvas"
      (onActionFired)="onActionFired($event)"></app-bead-canvas>
  </mat-sidenav-content>
  <mat-sidenav #rightSidebar mode="side" position="end" [opened]="rightSidebarOpen" style="width: 321px"
    class="sidebar">
    <mat-tab-group [(selectedIndex)]="selectedTabIndex">
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="sidebar-icon">texture</mat-icon>
          <span class="sidebar-title">{{
            httpService.getTransation().Pattern
            }}</span>
        </ng-template>
        <div style="
            display: flex;
            flex-direction: column;
            padding-left: 8px;
            padding-right: 8px;
            padding-top: 8px;
          ">
          <div fxFlexFill>
            <mat-form-field fxFlex="40" style="padding-right: 8px">
              <mat-select [placeholder]="httpService.getTransation().Stitch" [value]="getStitch()"
                (selectionChange)="onStitchSelected($event.value)">
                <mat-option *ngFor="let s of stitchs" [value]="s">{{
                  s.name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field fxFlex="30" style="padding-right: 8px">
              <input matInput [placeholder]="httpService.getTransation().Columns" type="text" inputmode="numeric"
                pattern="[0-9]*" min="5" max="500" [value]="bcanvas.getCols()" (change)="onColsChange($event)"
                (click)="$event.target.select()" />
              <mat-hint align="end">{{ getColumnsSize() }}</mat-hint>
            </mat-form-field>
            <mat-form-field fxFlex="30">
              <input matInput [placeholder]="httpService.getTransation().Rows" type="text" inputmode="numeric"
                pattern="[0-9]*" min="5" max="500" [value]="bcanvas.getRows()" (change)="onRowsChange($event)"
                (click)="$event.target.select()" />
              <mat-hint align="end">{{ getRowsSize() }}</mat-hint>
            </mat-form-field>
          </div>
          <app-pattern-palettes-list #patternPaletteList [bcanvas]="bcanvas" (selectedPaletteDetailChanged)="
              selectedPaletteDetailChanged($event)
            " [height]="patternListHeight">
          </app-pattern-palettes-list>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="sidebar-icon">palette</mat-icon>
          <span class="sidebar-title">{{
            httpService.getTransation().Palettes
            }}</span>
        </ng-template>
        <app-palettes-list #paletteList (selectedPaletteDetailChanged)="selectedPaletteDetailChanged($event)"
          (onPaletteDetailsLoaded)="onPaletteDetailsLoaded()" [height]="paletteListHeight" [includePadding]="true"
          [includeBuiltIn]="true" [includeCustom]="true">
        </app-palettes-list>
      </mat-tab>
    </mat-tab-group>
  </mat-sidenav>
</mat-sidenav-container>

<!-- Help Panel Backdrop -->
<div class="help-panel-backdrop" *ngIf="helpPanelOpen && !hasOpenModals" (click)="closeHelpPanel()"></div>



<!-- Help Panel -->
<aside *ngIf="!hasOpenModals" id="help-panel" class="help-panel" [class.open]="helpPanelOpen" role="dialog"
  aria-modal="false" aria-labelledby="help-panel-title">
  <div class="help-panel-header">
    <div>
      <h3 id="help-panel-title">
        {{ httpService.getTransation().HelpPanelTitle || 'Need help?' }}
      </h3>
      <p class="help-panel-subtitle">
        {{
        httpService.getTransation().HelpPanelSubtitle ||
        'Quick answers, tutorials, and support without leaving the app.'
        }}
      </p>
    </div>
    <button mat-icon-button (click)="closeHelpPanel()"
      [matTooltip]="httpService.getTransation().HelpClose || 'Close help'">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <section class="help-panel-section">
    <h4>{{ httpService.getTransation().HelpFaqHeading || 'Quick answers' }}</h4>
    <mat-accordion>
      <mat-expansion-panel *ngFor="let faq of helpFaqItems; let i = index">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ httpService.getTransation()[faq.questionKey] }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p>{{ httpService.getTransation()[faq.answerKey] }}</p>
      </mat-expansion-panel>
    </mat-accordion>
  </section>

  <section class="help-panel-section">
    <h4>
      {{ httpService.getTransation().HelpContactHeading || 'Contact support' }}
    </h4>
    <p>
      {{
      httpService.getTransation().HelpContactDescription ||
      'If you find a bug or get stuck, send us a note and we will reply quickly.'
      }}
    </p>
    <div class="help-email-container">
      <a class="help-panel-link" [href]="supportEmailLink">
        <mat-icon>mail</mat-icon>
        {{
        httpService.getTransation().HelpContactEmailCta ||
        'Email support@beadpatternmaker.com'
        }}
      </a>
      <button mat-icon-button class="help-copy-button" (click)="copySupportEmailToClipboard()"
        [matTooltip]="emailCopied ? 'Copied!' : 'Copy email address'">
        <mat-icon>{{ emailCopied ? 'check' : 'content_copy' }}</mat-icon>
      </button>
    </div>
  </section>

  <section class="help-panel-section">
    <h4>
      {{ httpService.getTransation().HelpTutorialHeading || 'Mini tutorial' }}
    </h4>
    <p>
      {{
      httpService.getTransation().HelpTutorialDescription ||
      'Watch a 2-minute walkthrough of the main tools.'
      }}
    </p>
    <button mat-stroked-button color="primary" (click)="launchHelpTutorial()">
      <mat-icon>play_circle</mat-icon>
      {{ httpService.getTransation().VideoTutorial || 'Video Tutorial' }}
    </button>
  </section>
</aside>